import globalConfigMarshaller from './globalConfigMarshaller';
import formConfigMarshaller from './formConfigMarshaller';
import termsConfigMarshaller from './termsConfigMarshaller';
import localStorageValuesMarshaller from './localStorageValuesMarshaller';
import formSessionMarshaller from './formSessionMarshaller';
import customFieldsMarshaller from './customFieldsMarshaller';

const allMarshallers = {
  globalConfigMarshaller,
  formConfigMarshaller,
  localStorageValuesMarshaller,
  termsConfigMarshaller,
  formSessionMarshaller,
  customFieldsMarshaller,
};

export default allMarshallers;
